export default __webpack_public_path__ + "static/media/receipt-pos.4ded4ac2.jpg";